import { PropTypes } from "prop-types"

import Label from "../Label"
import OptionalIndicator from "./OptionalIndicator"

export function FieldLabel({ children, id, inputId, label, required }) {
  return (
    <Label className="oj-field-label" inputId={inputId} id={id} required={required}>
      <span className="label-text">
        {label}
        {!required && <OptionalIndicator />}
      </span>
      {children}
    </Label>
  )
}

FieldLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
  id: PropTypes.string,
  inputId: PropTypes.string,
  required: PropTypes.bool
}

export default FieldLabel
